<section class="what-is-schema" [dir]="lang.getDir()">
  <div class="schema-container">
    <div class="schema-image">
      <img src="assets/what-is-schema.png" alt="SchemaFirst concept" class="responsive-image animate-pop-in" />
    </div>
    <div class="schema-text">
      <h2 class="section-title animate-slide-in">{{ 'what.title' | translate }}</h2>
      <p class="section-text animate-fade-in">{{ 'what.p1' | translate }}</p>
      <p class="section-text animate-fade-in-delay">{{ 'what.p2' | translate }}</p>
    </div>
  </div>
</section>
